module.exports = __webpack_public_path__ + "img/3.f3d58d01.png";